// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Components
import { Divider } from "@material-ui/core";
import { PopUp } from "@components/Modals";
import { Button } from "@components/Input";
import ElementColor from "../element_color";
import ElementSwitch from "../element_switch";
import ThemeSelector from "./theme_selector";

class Themes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      custom_open: false,
      save_config: "",
      themes: [
        {
          name: "centribal_dark",
          description: "Centribal Dark",
          colors: {
            primary: "#323756",
            secondary: "#F2F5FC",
            tertiary: "#F0A81F"
          }
        },
        {
          name: "centribal_light",
          description: "Centribal Light",
          colors: {
            primary: "#F7F9FF",
            secondary: "#454B6E",
            tertiary: "#5FA9E6"
          }
        },
        {
          name: "dark",
          description: "Dark",
          colors: {
            primary: "#07090C",
            secondary: "#C7CED9",
            tertiary: "#334155"
          }
        },
        {
          name: "dracula_dark",
          description: "Dracula Dark",
          colors: {
            primary: "#282A36",
            secondary: "#F8F8F2",
            tertiary: "#6272A4"
          }
        },
        {
          name: "dracula_light",
          description: "Dracula Light",
          colors: {
            primary: "#F8F8F2",
            secondary: "#282A36",
            tertiary: "#6272A4"
          }
        },
        {
          name: "coffee_dark",
          description: "Coffee Dark",
          colors: {
            primary: "#F7F3EE",
            secondary: "#3F3A36",
            tertiary: "#D4A373"
          }
        },
        {
          name: "coffee_light",
          description: "Coffee Light",
          colors: {
            primary: "#FDFBF8",
            secondary: "#6A625C",
            tertiary: "#C9A27E"
          }
        },
        {
          name: "nord_light",
          description: "Nord Light",
          colors: {
            primary: "#ECEFF4",
            secondary: "#2E3440",
            tertiary: "#88C0D0"
          }
        },
        {
          name: "nord_dark",
          description: "Nord Dark",
          colors: {
            primary: "#2E3440",
            secondary: "#ECEFF4",
            tertiary: "#81A1C1"
          }
        },
        {
          name: "sunset",
          description: "Sunset",
          colors: {
            primary: "#2B2D42",
            secondary: "#F8EDEB",
            tertiary: "#F4A261"
          }
        },
        {
          name: "forest",
          description: "Forest",
          colors: {
            primary: "#1F3D2B",
            secondary: "#F1F7F3",
            tertiary: "#6BAA75"
          }
        },
        {
          name: "ocean",
          description: "Ocean",
          colors: {
            primary: "#0B2545",
            secondary: "#EAF4FF",
            tertiary: "#2EC4B6"
          }
        },
        {
          name: "midnight_blue",
          description: "Midnight Blue",
          colors: {
            primary: "#0F172A",
            secondary: "#E2E8F0",
            tertiary: "#38BDF8"
          }
        },
        {
          name: "sandstone",
          description: "Crimson Ember",
          colors: {
            primary: "#2B0F14",
            secondary: "#FDECEF",
            tertiary: "#C1121F"
          }
        },
        {
          name: "mint_fresh",
          description: "Mint Fresh",
          colors: {
            primary: "#EAFBF5",
            secondary: "#1F3A32",
            tertiary: "#34D399"
          }
        },
        {
          name: "rose_dusk",
          description: "Rose Dusk",
          colors: {
            primary: "#2D1E2F",
            secondary: "#FBEFF4",
            tertiary: "#E779A8"
          }
        },
        {
          name: "graphite",
          description: "Graphite",
          colors: {
            primary: "#1E1E24",
            secondary: "#F5F7FA",
            tertiary: "#7C8DB5"
          }
        },
        {
          name: "aurora",
          description: "Aurora",
          colors: {
            primary: "#0B132B",
            secondary: "#F0F4F8",
            tertiary: "#6FFFE9"
          }
        },
        {
          name: "terracotta",
          description: "Terracotta",
          colors: {
            primary: "#3D2C2E",
            secondary: "#FAF5F0",
            tertiary: "#E07A5F"
          }
        },
        {
          name: "slate_light",
          description: "Slate Light",
          colors: {
            primary: "#F8FAFC",
            secondary: "#1E293B",
            tertiary: "#64748B"
          }
        },
        {
          name: "emerald_night",
          description: "Emerald Night",
          colors: {
            primary: "#102A23",
            secondary: "#E6FFFA",
            tertiary: "#2EC4B6"
          }
        },
        {
          name: "minimal_neutro",
          description: "Minimal Neutro",
          colors: {
            primary: "#FFFFFF",
            secondary: "#111827",
            tertiary: "#9CA3AF"
          }
        },
        {
          name: "new",
          description: "custom",
          colors: {
            primary: "#565671",
            secondary: "#FFFFFF",
            tertiary: "#F4AC1A"
          }
        }
      ]
    };
  }

  updateIconConfig = (bool) => {
    const { config, updateConfig } = this.props;
    config.customization.messages_user_icon_show = bool;
    config.customization.messages_agent_icon_show = bool;

    updateConfig(config);
  };

  updateElementConfig = (theme) => {
    const { config, updateConfig } = this.props;

    var primary = theme.colors.primary,
      secondary = theme.colors.secondary,
      tertiary = theme.colors.tertiary;

    /* HEADER */
    config.customization.header_text_color = primary;
    config.customization.header_bg_color = secondary;
    config.customization.header_icons_color = primary;
    /* CONTENT */
    config.customization.messages_content_bg_color = primary;
    config.customization.chat_bg_color = primary;
    /* MESSAGES */
    config.customization.messages_agent_text_color = primary;
    config.customization.messages_agent_bg_color = tertiary;
    config.customization.messages_user_text_color = primary;
    config.customization.messages_user_bg_color = secondary;
    /* BUTTONS*/
    config.customization.artifacts_button_text_color = primary;
    config.customization.artifacts_button_bg_color = secondary;
    config.customization.artifacts_button_hover_text_color = secondary;
    config.customization.artifacts_button_hover_bg_color = primary;
    config.customization.artifacts_button_disabled_text_color = primary;
    config.customization.artifacts_button_disabled_bg_color = "#C4C4C4";
    config.customization.artifacts_link_button_text_color = primary;
    config.customization.artifacts_link_button_bg_color = secondary;
    config.customization.artifacts_link_button_hover_text_color = secondary;
    config.customization.artifacts_link_button_hover_bg_color = primary;
    /* INPUT */
    config.customization.input_text_color = primary;
    config.customization.input_bg_color = secondary;
    config.customization.input_icon_color = secondary;
    config.customization.input_icon_bg_color = primary;
    config.customization.input_clip_color = secondary;
    config.customization.input_clip_bg_color = primary;
    /* OPEN CHAT */
    config.customization.open_text_color = secondary;
    config.customization.open_bg_color = primary;

    updateConfig(config);
  };

  activeTheme = (theme) => {
    const { config } = this.props;

    var primary = theme.colors.primary,
      secondary = theme.colors.secondary,
      tertiary = theme.colors.tertiary;

    var active = [];

    /* HEADER */
    active.push(config.customization.header_text_color === primary);
    active.push(config.customization.header_bg_color === secondary);
    active.push(config.customization.header_icons_color === primary);
    /* CONTENT */
    active.push(config.customization.messages_content_bg_color === primary);
    active.push(config.customization.chat_bg_color === primary);
    /* MESSAGES */
    active.push(config.customization.messages_agent_text_color === primary);
    active.push(config.customization.messages_agent_bg_color === tertiary);
    active.push(config.customization.messages_user_text_color === primary);
    active.push(config.customization.messages_user_bg_color === secondary);
    /* BUTTONS*/
    active.push(config.customization.artifacts_button_text_color === primary);
    active.push(config.customization.artifacts_button_bg_color === secondary);
    active.push(
      config.customization.artifacts_button_hover_text_color === secondary
    );
    active.push(
      config.customization.artifacts_button_hover_bg_color === primary
    );
    active.push(
      config.customization.artifacts_button_disabled_text_color === primary
    );
    active.push(
      config.customization.artifacts_button_disabled_bg_color === "#C4C4C4"
    );
    active.push(
      config.customization.artifacts_link_button_text_color === primary
    );
    active.push(
      config.customization.artifacts_link_button_bg_color === secondary
    );
    active.push(
      config.customization.artifacts_link_button_hover_text_color === secondary
    );
    active.push(
      config.customization.artifacts_link_button_hover_bg_color === primary
    );
    /* INPUT */
    active.push(config.customization.input_text_color === primary);
    active.push(config.customization.input_bg_color === secondary);
    active.push(config.customization.input_icon_color === secondary);
    active.push(config.customization.input_icon_bg_color === primary);
    active.push(config.customization.input_clip_color === secondary);
    active.push(config.customization.input_clip_bg_color === primary);
    /* OPEN CHAT */
    active.push(config.customization.open_text_color === secondary);
    active.push(config.customization.open_bg_color === primary);

    var a = active.filter((act) => act === false);
    return a.length === 0;
  };

  returnPopUpContent = () => {
    const { themes } = this.state;
    const theme = themes.filter((th) => th.name === "new")[0];
    return (
      <React.Fragment>
        <div className="elements_custom grid">
          <div>
            <ElementColor
              updateCustomization={this.updateColors}
              element={"primary"}
              value={theme.colors.primary}
              value_updated={"primary"}
            />
            <ElementSwitch
              color_1={"primary"}
              color_2={"secondary"}
              updateConfig={this.updateColors}
              config={theme}
            />
            <ElementColor
              updateCustomization={this.updateColors}
              element={"secondary"}
              value={theme.colors.secondary}
              value_updated={"secondary"}
            />
          </div>
          <ElementColor
            updateCustomization={this.updateColors}
            element={"tertiary"}
            value={theme.colors.tertiary}
            value_updated={"tertiary"}
          />
        </div>
      </React.Fragment>
    );
  };

  updateColors = (e, type, subtype) => {
    const { themes } = this.state;
    const theme = themes.filter((th) => th.name === "new")[0];

    if (!e?.error) {
      theme.colors[subtype] = e?.css?.backgroundColor;
    } else {
      theme.colors[subtype] = e.raw;
    }

    this.setState({ themes: themes });
    this.updateElementConfig(theme);
  };

  saveConfig = (theme) => {
    this.setState({
      custom_open: true,
      config: JSON.parse(JSON.stringify(this.props.config))
    });
    this.updateElementConfig(theme);
  };

  cancelSave = () => {
    const { config } = this.state;
    const { updateConfig } = this.props;
    updateConfig(config);
    this.setState({ custom_open: false });
  };

  render() {
    const { t, config } = this.props;
    const { themes, custom_open } = this.state;
    const activeThemeName = themes.find(
      (theme) => theme.name !== "new" && this.activeTheme(theme)
    )?.name;

    return (
      <div className="nlp-config">
      <div className={"cen_card"}>
        {/* THEME COLOR */}
        <div className={"content"}>
          <div className="elements_custom grid">
            <div className="elements_custom__info">
              <span className="elements_custom__title">
                {t(
                  "card.content.project.web_interface.customization.themes.colors.title"
                )}
              </span>
              <span className="elements_custom__description">
                {t(
                  "card.content.project.web_interface.customization.themes.colors.description"
                )}
              </span>
            </div>
            <ThemeSelector
              themes={themes}
              activeThemeName={activeThemeName}
              onThemeSelect={this.updateElementConfig}
              onCustomThemeClick={this.saveConfig}
              customLabel={"Custom"}
            />
            <PopUp
              open={custom_open}
              className={"popup_container"}
              handleClose={() => this.cancelSave()}
              t={t}
              width={400}
              content={this.returnPopUpContent()}
              buttons={
                <Button
                  type={"success"}
                  onClick={() => this.setState({ custom_open: false })}
                  text={t("card.content.project.web_interface.button_accept")}
                />
              }
            />
          </div>
        </div>
        <Divider />
        {/* ICONS */}
        <div className={"content"}>
          <div className="elements_custom grid">
            <div className="elements_custom__info">
              <span className="elements_custom__title">
                {t(
                  "card.content.project.web_interface.customization.themes.icons.title"
                )}
              </span>
              <span className="elements_custom__description">
                {t(
                  "card.content.project.web_interface.customization.themes.icons.description"
                )}
              </span>
            </div>
            <div className={"elements__themes"}>
              <div
                onClick={() => this.updateIconConfig(true)}
                className={"elements__themes_element"}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/img/design/themes/show_icons.png`}
                  alt={"normal"}
                />
                <span>
                  {t(
                    "card.content.project.web_interface.customization.themes.icons.show"
                  )}
                </span>
                {config.customization.messages_user_icon_show &&
                  config.customization.messages_agent_icon_show && (
                    <div className={"elements__themes_element_selected"} />
                  )}
              </div>
              <div
                onClick={() => this.updateIconConfig(false)}
                className={"elements__themes_element"}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/img/design/themes/hide_icons.png`}
                  alt={"normal"}
                />
                <span>
                  {t(
                    "card.content.project.web_interface.customization.themes.icons.hide"
                  )}
                </span>
                {!config.customization.messages_user_icon_show &&
                  !config.customization.messages_agent_icon_show && (
                    <div className={"elements__themes_element_selected"} />
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const a = connect(mapStateToProps)(Themes);

export default withTranslation("common")(withRouter(a));
